import { render, staticRenderFns } from "./PlanningSprints.vue?vue&type=template&id=538ed03f&"
import script from "./PlanningSprints.vue?vue&type=script&lang=js&"
export * from "./PlanningSprints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports